<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <b-breadcrumb
        :items="items"
        class="pl-0 pt-5 mt-5 bg-transparent"
      ></b-breadcrumb>
      <h2 class="font-weight-bold">New Request</h2>
      <b-card class="mt-4">
        <div class="mx-auto p-lg-5 w-75">
          <h4 class="font-weight-bold mb-4">
            File Details
          </h4>
          <new-request-form />
        </div>
      </b-card>
    </b-container>
  </transition>
</template>

<script>
import NewRequestForm from '@/components/forms/NewRequestForm'

export default {
  components: {
    NewRequestForm
  },
  data() {
    return {}
  },
  computed: {
    items() {
      return [
        { text: 'File Request', to: '/request/templates' },
        { text: 'New Request' }
      ]
    }
  }
}
</script>
